import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import BgImg from "../../assets/img/website-images/About-us-anjanadri.jpg";

function Main({ subtitle, title }) {

    /* GSAP: Ken Burns zoom-out on bg */
    const sectionRef = useRef(null);
    useEffect(() => {
        if (sectionRef.current) {
            gsap.fromTo(
                sectionRef.current,
                { backgroundSize: '115%' },
                { backgroundSize: 'cover', duration: 1.8, ease: 'power2.out' }
            );
        }
    }, []);

    /* GSAP: shimmer sweep */
    const shimmerRef = useRef(null);
    useEffect(() => {
        if (shimmerRef.current) {
            gsap.fromTo(
                shimmerRef.current,
                { x: '-100%', opacity: 0.5 },
                { x: '250%', opacity: 0, duration: 1.3, ease: 'power2.inOut', delay: 0.25 }
            );
        }
    }, []);

    return (
        <>
            <section
                ref={sectionRef}
                className="breadcrumb-area d-flex p-relative align-items-center"
                style={{ backgroundImage: `url(${BgImg})` }}
            >
                {/* Shimmer — absolutely positioned, won't affect layout */}
                <div
                    ref={shimmerRef}
                    style={{
                        position: 'absolute', top: 0, left: 0,
                        width: '45%', height: '100%',
                        background: 'linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.1) 50%, transparent 80%)',
                        pointerEvents: 'none',
                        zIndex: 5,
                    }}
                />

                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12 col-lg-12">
                            <div className="breadcrumb-wrap text-left">
                                <div className="breadcrumb-title">

                                    {/* Title — fires on page load */}
                                    <motion.h2
                                        initial={{ opacity: 0, y: 35, skewY: 2 }}
                                        animate={{ opacity: 1, y: 0, skewY: 0 }}
                                        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
                                    >
                                        {subtitle}
                                    </motion.h2>

                                </div>
                            </div>
                        </div>

                        {/* Breadcrumb trail — exact original structure */}
                        <div className="breadcrumb-wrap2">
                            <nav aria-label="breadcrumb">
                                <motion.ol
                                    className="breadcrumb"
                                    initial="hidden"
                                    animate="visible"
                                    variants={{
                                        hidden: {},
                                        visible: {
                                            transition: { staggerChildren: 0.14, delayChildren: 0.5 },
                                        },
                                    }}
                                >
                                    <motion.li
                                        className="breadcrumb-item"
                                        variants={{
                                            hidden: { opacity: 0, x: -15 },
                                            visible: { opacity: 1, x: 0, transition: { duration: 0.4, ease: 'easeOut' } },
                                        }}
                                    >
                                        <Link to="/">{title}</Link>
                                    </motion.li>

                                    <motion.li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                        variants={{
                                            hidden: { opacity: 0, x: -15 },
                                            visible: { opacity: 1, x: 0, transition: { duration: 0.4, ease: 'easeOut' } },
                                        }}
                                    >
                                        {subtitle}
                                    </motion.li>
                                </motion.ol>
                            </nav>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}

export default Main;
